import { Dialog, DialogTitle, DialogContent, IconButton, Tooltip, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import CustomTable from "../../components/customTable/CustomTable";

import { createMRTColumnHelper } from "material-react-table";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";


const ShowTransactionModal = ({ showTransactionsData, openTransaction, onClose, }) => {
    // console.log("showTransactionsData: in table", showTransactionsData);
    // const sliceResponse = data?.allTransactions;
    const sliceResponse = showTransactionsData
    // console.log("sliceResponse: in showtransaction  ", sliceResponse);

    const sliceResponseData = sliceResponse?.map((item) => ({
        id: item._id || "N/A",
        price: item.Price || "N/A",
        amount: item.amount || "N/A",
        clientId: item.client_id?._id || "N/A",
        clientName: item.client_id?.name || "N/A",
        commission: item.commission || "N/A",
        createdAt: item.createdAt || "N/A",
        customerRefNo: item.customerRefNo || "N/A",
        partner_comm_per: item.partner_comm_per || "N/A",
        flag: item.flag || "N/A",
        gst: item.gst || "N/A",
        invoiceNo: item.invoice_No || "N/A",
        invoiceUrl: item.invoice_url || "N/A",
        merchantTransactionId: item.merchant_transaction_id || "N/A",
        metalType: item.metal_type || "N/A",
        orderId: item.orderID || "N/A",
        partnerId: item.partner_id || "N/A",
        paymentId: item.payment_id || "N/A",
        paymentMethod: item.payment_method || "N/A",
        proposalId: item.proposal_id || "N/A",
        quantity: item.quantity || "N/A",
        status: item.status || "N/A",
        totalAmount: item.total_amount || "N/A",
        transactionId: item.transaction_id || "N/A",
        preTaxAmount: item.preTaxAmount || "N/A",
        updatedAt: item.updatedAt || "N/A",
    }));

    const columnHelper = createMRTColumnHelper();
    const columns = [
        columnHelper.accessor("clientId", {
            header: "Client ID",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell.row.original?.clientId);
                    toast.success("copied to clipboard!");
                };

                return (
                    <Tooltip title={cell.row.original?.clientId}>
                        <div>
                            <IconButton onClick={handleCopy}>
                                <ContentCopy />
                            </IconButton>
                            {cell.row.original?.clientName || "Batuk Customer"}
                        </div>
                    </Tooltip>
                );
            },
        }),

        columnHelper.accessor("id", {
            header: "Transaction ID",
            size: 30,
            Cell: (cell) => cell.row.original?.id || "N/A",
        }),

        columnHelper.accessor("invoiceNo", {
            header: "Invoice No",
            size: 30,
            Cell: (cell) => cell.row.original?.invoiceNo || "N/A",
        }),
        columnHelper.accessor("invoiceUrl", {
            header: "Invoice URL",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell.row.original?.invoiceUrl);
                    toast.success("URL copied to clipboard!");
                };

                return (
                    <Tooltip title={cell.row.original?.invoiceUrl}>
                        <IconButton onClick={handleCopy}>
                            <ContentCopy />
                        </IconButton>
                    </Tooltip>
                );
            },
        }),
        columnHelper.accessor("merchantTransactionId", {
            header: "Merchant Transaction ID",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(
                        cell.row.original?.merchantTransactionId
                    );
                    toast.success("copied to clipboard!");
                };

                return (
                    <Tooltip title={cell.row.original?.merchantTransactionId}>
                        <div>
                            <IconButton onClick={handleCopy}>
                                <ContentCopy />
                            </IconButton>
                            {cell.row.original?.merchantTransactionId}
                        </div>
                    </Tooltip>
                );
            },
        }),

        columnHelper.accessor("customerRefNo", {
            header: "Customer Ref No",
            size: 30,
            Cell: (cell) => cell.row.original?.customerRefNo || "N/A",
        }),

        columnHelper.accessor("partnerId", {
            header: "Partner ID",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell.row.original?.partnerId);
                    toast.success("copied to clipboard!");
                };
                return (
                    <Tooltip title={cell.row.original?.partnerId}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <IconButton onClick={handleCopy}>
                                <ContentCopy />
                            </IconButton>
                            {cell.row.original?.partnerName}
                        </div>
                    </Tooltip>
                );
            },
        }),

        columnHelper.accessor("proposalId", {
            header: "Proposal ID",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell.row.original?.proposalId);
                    toast.success("copied to clipboard!");
                };
                return (
                    <Tooltip title={cell.row.original?.proposalId}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <IconButton onClick={handleCopy}>
                                <ContentCopy />
                            </IconButton>
                            {cell.row.original?.proposalId}
                        </div>
                    </Tooltip>
                );
            },
        }),

        columnHelper.accessor("metalType", {
            header: "Metal Type",
            size: 30,
            Cell: (cell) => cell.row.original?.metalType || "N/A",
        }),
        columnHelper.accessor("quantity", {
            header: "Quantity",
            size: 30,
            Cell: (cell) => cell.row.original?.quantity || "N/A",
        }),
        columnHelper.accessor("price", {
            header: "Price",
            size: 30,
            Cell: (cell) => cell.row.original?.price || "N/A",
        }),

        // Payment Details
        columnHelper.accessor("totalAmount", {
            header: "Total Amount",
            size: 30,
            Cell: (cell) => cell.row.original?.totalAmount || "N/A",
        }),
        columnHelper.accessor("preTaxAmount", {
            header: "Pre Tax Amount",
            size: 30,
            Cell: (cell) => cell.row.original?.preTaxAmount || "N/A",
        }),
        columnHelper.accessor("commission", {
            header: "Commission",
            size: 30,
            Cell: (cell) => cell.row.original?.commission || "N/A",
        }),
        columnHelper.accessor("partner_comm_per", {
            header: "Partner Commission",
            size: 30,
            Cell: (cell) => cell.row.original?.partner_comm_per || "N/A",
        }),
        columnHelper.accessor("gst", {
            header: "GST",
            size: 30,
            Cell: (cell) => cell.row.original?.gst || "N/A",
        }),
        columnHelper.accessor("paymentMethod", {
            header: "Payment Method",
            size: 30,
            Cell: (cell) => cell.row.original?.paymentMethod || "N/A",
        }),

        // Status and Metadata
        columnHelper.accessor("status", {
            header: "Status",
            size: 30,
            Cell: (cell) => cell.row.original?.status || "N/A",
        }),
        columnHelper.accessor("flag", {
            header: "Flag",
            size: 30,
            Cell: (cell) => cell.row.original?.flag || "N/A",
        }),
        columnHelper.accessor("createdAt", {
            header: "Created At",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original.createdAt.split("T")[0]}
                </div>
            ),
        }),
        columnHelper.accessor("updatedAt", {
            header: "Updated At",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original.createdAt.split("T")[0]}
                </div>
            ),
        }),
    ];

    return (
        <>
           {/*  */}
            <Dialog
                open={openTransaction}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                sx={{
                    position: "fixed",
                    top: "10%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1000,
                    // backgroundColor: "red", // Ensures solid background

                }}
                PaperProps={{
                    sx: {
                        boxShadow: "none", // Removes shadow completely
                        backgroundColor: "white", // Ensures solid background
                        // backgroundColor: "red", // Ensures solid background
                        border: "none", // Removes any border
                    },
                }}
                BackdropProps={{
                    sx: {
                        backgroundColor: "transparent", // Removes any overlay effect
                        // backgroundColor: "red", // Removes any overlay effect
                    },
                }}
            >
                <DialogTitle sx={{ backgroundColor: "#f7f7f7" }}>
                    Transactions
                    <div style={{ position: "absolute", right: 16, top: 8 }}>
                        <Tooltip title="Close">
                            <IconButton onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#f7f7f7" }}>
                    <CustomTable columns={columns} data={sliceResponseData} />
                </DialogContent>
            </Dialog>


            {/* <Dialog
                open={openTransaction}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
            
                sx={{ position: "fixed", top: "10%", left: "50%", transform: "translateX(-50%)", zIndex: 1000 }}
                
            >
                <DialogTitle>
                    Transactions
                    <div style={{ position: "absolute", right: 16, top: 8 }}>
                        <Tooltip title="Close">
                            <IconButton onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Box>
                    <CustomTable columns={columns} data={sliceResponseData} />
                    </Box>
                </DialogContent>
            </Dialog> */}

            {/* <Dialog open={openTransaction} onClose={onClose} maxWidth="md" fullWidth sx={{ zIndex: 1000 ,mt:5,ml:10}}>
                <DialogTitle>
                    Transactions
                    <div style={{ position: "absolute", right: 16, top: 8 }}>
                        <Tooltip title="Close" >
                            <IconButton onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent>

                    <Box>

                        <CustomTable columns={columns} data={sliceResponseData} />
                    </Box>

                </DialogContent>
            </Dialog> */}
        </>
    );
};

export default ShowTransactionModal;
